import React from 'react';
import { Check, AlertTriangle } from 'lucide-react';
import { SizeSpacingPanel, ColorsFontsPanel } from '../common/BlockStyleSettings';
import { BLOCK_FEATURES } from '../common/commonDefaults';

const CALENDLY_URL_REGEX = /^https?:\/\/(www\.)?calendly\.com\/.+/i;

/**
 * CalendlyEditor - Editor component for calendly block
 */
const CalendlyEditor = ({ block, onChange, theme, hideStylePanels }) => {
  const { content } = block;

  const handleChange = (field, value) => {
    onChange({ [field]: value });
  };

  const handleStyleChange = (styleUpdates) => {
    onChange({ style: { ...(content.style || {}), ...styleUpdates } });
  };

  const features = BLOCK_FEATURES['calendly'];

  const calendlyUrl = content.calendlyUrl || '';
  const isUrlValid = CALENDLY_URL_REGEX.test(calendlyUrl);
  const showValidation = calendlyUrl.length > 0;

  return (
    <div className="space-y-4">
      {/* Calendly URL */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-1">
          Calendly URL
        </label>
        <div className="relative">
          <input
            type="text"
            value={calendlyUrl}
            onChange={(e) => handleChange('calendlyUrl', e.target.value)}
            placeholder="https://calendly.com/your-name"
            className={`w-full px-3 py-2 bg-[#1a1a2e] border rounded-lg text-white placeholder-gray-500 focus:outline-none pr-10 ${
              showValidation
                ? isUrlValid
                  ? 'border-green-500 focus:border-green-500'
                  : 'border-red-500 focus:border-red-500'
                : 'border-gray-700 focus:border-[#749555]'
            }`}
          />
          {showValidation && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2">
              {isUrlValid ? (
                <Check size={16} className="text-green-500" />
              ) : (
                <AlertTriangle size={16} className="text-red-500" />
              )}
            </div>
          )}
        </div>
        {showValidation && !isUrlValid && (
          <p className="text-xs text-red-400 mt-1">
            URL must start with https://calendly.com/
          </p>
        )}
      </div>

      {/* Button Text */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-1">
          Button Text
        </label>
        <input
          type="text"
          value={content.buttonText || ''}
          onChange={(e) => handleChange('buttonText', e.target.value)}
          placeholder="Schedule a Meeting"
          className="w-full px-3 py-2 bg-[#1a1a2e] border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:border-[#749555] focus:outline-none"
        />
      </div>

      {/* Style Panels */}
      {!hideStylePanels && (<>
        <SizeSpacingPanel
          style={content.style || {}}
          onChange={handleStyleChange}
          features={features}
        />
        <ColorsFontsPanel
          style={content.style || {}}
          onChange={handleStyleChange}
          features={features}
          theme={theme || {}}
          blockType="calendly"
        />
      </>)}
    </div>
  );
};

export default CalendlyEditor;
